import { BaseDialog } from "@certa/catalyst/components/Dialog/BaseDialog";
import { ErrorBoundary } from "@certa/common/components/ErrorBoundary";
import { useNavigationDrawer } from "../NavigationSidebar";
import { SearchLayout } from "./components/SearchLayout";
import { useSearchStore } from "./store/useSearchStore";

const GlobalSearchNext = () => {
  const { isSearchModalOpen, setIsSearchModalOpen } = useNavigationDrawer();
  const { resetSearch, isChildDialogOpen } = useSearchStore();

  const handleSearchDialogClose = () => {
    setIsSearchModalOpen(false);
    resetSearch();
  };

  return (
    <BaseDialog
      show={isSearchModalOpen}
      onClose={handleSearchDialogClose}
      width="90%"
      maxWidth="1200px"
      height="80%"
      shouldDisableDialogClose={isChildDialogOpen}
      aria-label="Global Search"
    >
      <ErrorBoundary>
        <SearchLayout />
      </ErrorBoundary>
    </BaseDialog>
  );
};

export { GlobalSearchNext };
